import styled from 'styled-components'

export const Container = styled.ul`
  font-size: 75%;
  line-height: 2;

  li {
    color: #777777;
    list-style-type: none;
  }

  label {
    color: #fff;
  }
`